export default __webpack_public_path__ + "static/media/63fdd036-2f81-483e-9ca9-d774353563af.b674fcaf.woff2";